import { render, staticRenderFns } from "./btn-secondary.mpx?vue&type=template&id=a977c1a6&isComponent&outputPath=components%2Fbtn-secondarya185e16e%2Findex"
import script from "./btn-secondary.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-secondarya185e16e%2Findex"
export * from "./btn-secondary.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-secondarya185e16e%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports